import { Component, OnInit, inject } from "@angular/core";
import { Router } from "@angular/router";
import { AppTableComponent } from "../../../../Common/Components/Table/TableComponent";
import {
  TableActionConfig,
  TableColumn,
  TableConfig,
  TablePagination,
  TableSearchEvent,
  TableSort,
  TableDateRangeEvent,
} from "../../../../Common/Components/Table/Type/TableType";
import { File } from "../../Dto/FileModel";
import { FileEffects } from "../../State/FileEffect";
import { FileState } from "../../State/FileState";

@Component({
  selector: "app-file-home",
  standalone: true,
  imports: [AppTableComponent],
  templateUrl: "./FileHomePage.html",
  styleUrl: "./FileHomePage.scss",
})
export class FileHomePage implements OnInit {
  private readonly fileEffects = inject(FileEffects);
  private readonly router = inject(Router);
  readonly fileState = inject(FileState);

  filesColumns: TableColumn<File>[] = [
    { key: "id", header: "ID", sortable: true, width: "10%" },
    { key: "name", header: "Name", sortable: true, width: "15%" },
    { key: "originalName", header: "Original Name", sortable: true, width: "20%" },
    { key: "mimeType", header: "MIME Type", sortable: true, width: "15%" },
    { key: "remotePath", header: "Remote Path", sortable: true, width: "20%" },
    {
      key: "size",
      header: "Size",
      sortable: true,
      width: "10%",
      cellTemplate: (item) => this.formatFileSize(item.size),
    },
  ];

  get filesConfig(): TableConfig<File> {
    return {
      loading: this.fileState.loading(),
      emptyMessage: "No files found",
      showActions: true,
      showSearch: true,
      searchPlaceholder: "Search files...",
      showCreate: false,
      showDateRangeFilter: true,
      dateRangeFilterLabel: "Filter by upload date",
      actionButtons: [
        {
          icon: "open_in_new",
          label: "Open",
          handler: (item: File) => this.openFile(item),
          visible: () => true,
        },
      ],
    };
  }

  get filesPagination(): TablePagination {
    return this.fileState.pagination();
  }

  ngOnInit(): void {
    this.fileEffects.searchFiles({}).catch(() => undefined);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onSortChange(sort: TableSort | null): void {
    // Removed logging
  }

  onPageChange(event: { page: number; search?: string }): void {
    const currentSearchParams = this.fileState.searchParams();
    this.fileEffects.searchFiles({ ...currentSearchParams, page: event.page, search: event.search }).catch(() => undefined);
  }

  onPageSizeChange(event: { limit: number; search?: string }): void {
    const currentSearchParams = this.fileState.searchParams();
    this.fileEffects
      .searchFiles({ ...currentSearchParams, page: 1, limit: event.limit, search: event.search })
      .catch(() => undefined);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onActionClick<T>(event: { action: TableActionConfig<T>; item: T }): void {
    // Removed logging
  }

  onSearchChange(event: TableSearchEvent): void {
    this.fileEffects.searchFiles({ search: event.term, page: event.page }).catch(() => undefined);
  }

  onDateRangeChange(event: TableDateRangeEvent): void {
    const currentSearchParams = this.fileState.searchParams();
    this.fileEffects
      .searchFiles({
        ...currentSearchParams,
        page: event.page,
        createdAtFrom: event.dateRange.from,
        createdAtTo: event.dateRange.to,
      })
      .catch(() => undefined);
  }

  openFile(file: File): void {
    window.open(file.publicUrl, "_blank");
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return "0 Bytes";

    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  }
}
